import { themeVars } from '../theme/vars';
import { borderRadius, space } from '../tokens';
import { typography } from '../typography';
import { style } from '../layer.css';

const trackHeight = 4;
const thumbSize = 24;

export const sliderContainer = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s4,
});

export const slider = style({
  display: 'flex',
  position: 'relative',
  userSelect: 'none',
  touchAction: 'none',
  alignItems: 'center',

  selectors: {
    '&[data-disabled]': {
      opacity: 0.5,
      pointerEvents: 'none',
    },
  },
});

export const sliderTrack = style({
  position: 'relative',
  backgroundColor: themeVars.slider.background.default,
  borderRadius: borderRadius.r4,
  flexGrow: 1,
  height: trackHeight,

  selectors: {
    '&:after': {
      content: '',
      position: 'absolute',
      top: -(thumbSize - trackHeight) / 2,
      width: '100%',
      height: thumbSize,
    },
  },
});

export const sliderRange = style({
  position: 'absolute',
  backgroundColor: themeVars.slider.foreground.default,
  borderRadius: borderRadius.r4,
  height: '100%',
});

export const sliderThumb = style({
  display: 'block',
  height: thumbSize,
  width: thumbSize,
  backgroundColor: themeVars.slider.foreground.default,
  border: `1px solid ${themeVars.slider.background.default}`,
  borderRadius: '100%',
});

export const sliderLabel = style([
  typography['labelSm'],
  {
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: themeVars.container.foreground.tertiary,
    position: 'relative',
    zIndex: -1,
  },
]);

export const sliderLabelTextContainer = style([
  typography['labelSm'],
  {
    color: themeVars.container.foreground.primary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    width: '100%',
    position: 'absolute',
  },
]);

export const valueLabelContainer = style({
  ...typography['labelSm'],
  color: themeVars.slider.foreground.default,
  backgroundColor: themeVars.slider.background.default,
  width: '34px',
  height: '20px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '60px',
  opacity: 0,
  pointerEvents: 'none',
  whiteSpace: 'nowrap',
  position: 'absolute',
  left: '50%',
  top: -space.s8,
  transform: 'translate(-50%, -98%) scale(0.96)',
  transition: 'opacity 150ms',

  selectors: {
    [`${sliderThumb}:hover &, ${sliderThumb}:focus-visible &`]: {
      opacity: 1,
      transform: 'translate(-50%, -100%) scale(1)',
    },
  },
});

export const valueLabel = style({
  position: 'relative',
});

export const valueLabelTriangle = style({
  width: space.s10,
  height: space.s10,
  backgroundColor: themeVars.slider.background.default,
  rotate: '45deg',
  position: 'absolute',
  top: space.s14,
  clipPath: 'polygon(100% 0%, 100% 100%, 0% 100%)',
});
